module.exports = __webpack_public_path__ + "img/failed_camera.fc2e01cf.svg";